import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';
import groupBy from 'lodash/groupBy';
import { Observable } from 'rxjs';
import { Buffer } from 'buffer';

import { ReviewModalComponent } from '../shared/component/review-modal/review-modal.component';
import { FilterQueryComponent } from '../shared/component/filter-query/filter-query.component';
import { MessageComponent } from '../shared/component/message/message.component';
import { ReviewGroupService } from '../shared/service/review-group.service';
import { ListValueService } from "../shared/service/list-value.service";
import { ListValueModel } from '../shared/model/list-value.model';
import { ReviewService } from '../shared/service/review.service';
import { ReviewGroup } from '../shared/model/review-group.model';
import { ReviewCalc } from '../shared/model/review-calc.model';
import { UserService } from '../shared/service/user.service';
import { Exporting } from '../shared/static/exporting';
import { ListModel } from "../shared/model/list.model";

@Component({
    selector: 'app-review',
    templateUrl: './review.component.html',
    styleUrls: [ './review.component.css' ],
})
export class ReviewComponent extends FilterQueryComponent implements OnInit {
    selectMessage = 'Para salvar é necessario preencher os dados';
    loadListMessage = 'Carregando filtros e lista de valores';
    emptyMessage = 'Sem itens para visualizar';
    reportLink = '/review/review-detail';

    @ViewChild(ReviewModalComponent) modal: ReviewModalComponent;
    @ViewChild(MessageComponent) message: MessageComponent;
    lastEvent: any;

    constructor(
        protected reviewGroupService: ReviewGroupService,
        protected listValueService: ListValueService,
        private translateService: TranslateService,
        protected reviewService: ReviewService,
        protected userService: UserService,
        protected sanitizer: DomSanitizer,
    ) {
        super(userService);
    }

    seasonFilters = ['oleção', 'stação', 'eason'];
    statusFilters = ['status', 'resultado'];
    revFilters = ['reviewed', 'revisad'];
    factoryFilters = ['bric', 'actory'];
    lineFilters = ['inha', 'onstru'];
    brandFilters = ['arca', 'rand'];
    modelFilters = ['odel'];

    reprovedFilters = ['false', 'reprovado', 'não'];
    aprovedFilters = ['true', 'aprovado', 'sim'];

    hideOptions = ['user'];

    forceFilterResults: boolean = true;
    onlyInteger: boolean = true;
    showHidden: boolean = false;

    factoryOptions: ListView<ListValueModel>[] = [];
    seasonOptions: ListView<ListValueModel>[] = [];
    statusOptions: ListView<ListValueModel>[] = [];
    brandOptions: ListView<ListValueModel>[] = [];
    modelOptions: ListView<ListValueModel>[] = [];
    groupOptions: ListView<ListValueModel>[] = [];
    lineOptions: ListView<ListValueModel>[] = [];

    factoryList: ListValueModel[] = [];
    seasonList: ListValueModel[] = [];
    statusList: ListValueModel[] = [];
    modelList: ListValueModel[] = [];
    brandList: ListValueModel[] = [];
    lineList: ListValueModel[] = [];

    listOptionsReview: any = {};
    listOptions: any[] = [];
    list_id: number[] = [];

    reviewGroup: ReviewGroup = new ReviewGroup({});
    reviewCalc: ReviewCalc = new ReviewCalc({});

    groupedData: ReviewCalc[][] | any = [];
    allData: ReviewCalc[] | any = [];
    groupedDataDto: any = [];
    groupList: any[] = [];
    maxId = 999 * 1e+9;

    full_data_review_total: number;
    full_data_order_count: number;
    full_data_reviewed: number;
    full_data_balance: number;
    loadingOnTable: boolean;
    modalHasOpen: boolean;
    dataLenght: number;

    // Para criar um review direto pelo check, não está em uso
    selectedGroup: ReviewGroup = new ReviewGroup({});
    selectedFactory: ListValueModel;
    selectedSeason: ListValueModel;
    selectedModel: ListValueModel;
    selectedBrand: ListValueModel;
    selectedLine: ListValueModel;

    lists: ListModel[];

    listsLoaded: Promise<boolean>;
    resultLoaded: Promise<boolean>;

	ngOnInit() {
        this.loadFactoriesAndModels();
	}

    update(filter) {
        const search = filter;
        this.updateData(search);
    }

    updateData(search) {
        this.allData = [];
        this.loadingOnTable = true;
        this.message.info('loading_data_message');

        this.getNormalDataFromAPI(search);
        // this.getFullDataFromAPI(search);
    }

    getNormalDataFromAPI(response_query) {
        const review_query = this.changeQueryToIntegration(response_query);

        this.reviewService
        .getAll({ response_query, review_query, show_hidden: this.showHidden })
        // .getNormalDataFromSync({ response_query, review_query }) // for sync
        .pipe(take(1)).finally(() => this.addLogo())
        .subscribe((result: ReviewCalc[]) =>
            this.allData = result.map((rev) => new ReviewCalc(rev))
        );
    }

    getFullDataFromAPI(response_query) {
        const review_query = this.changeQueryToIntegration(response_query);

        this.reviewService
        .getAll({ response_query, review_query })
        // .getRecalcDataFromSync({ response_query, review_query }) // for sync
        .pipe(take(1)).finally(() => this.addLogo())
        .subscribe((result: ReviewCalc[]) =>
            this.allData = result.map((rev) => new ReviewCalc(rev))
        );
    }

    getFilterKeys = () => new Object({
        "factory": this.factoryFilters,
        "season": this.seasonFilters,
        "status": this.statusFilters,
        "model": this.modelFilters,
        "brand": this.brandFilters,
        "line": this.lineFilters,
        "reviewed": this.revFilters,
    });

    getKeyValues = () => new Object({
        "factory": this.factoryList,
        "season": this.seasonList,
        "status": this.statusList,
        "model": this.modelList,
        "brand": this.brandList,
        "line": this.lineList
    })

    getListById = (id, lists: any[]) => lists.find(list => list.id == id);

    changeQueryToIntegration(search) {
        const integrationQuery = {};
        const values = this.getFilterKeys();
        const fields = Object.getOwnPropertyNames(values);

        if (!search.list_filters) return;

        search.list_filters.forEach(
            (filter) => {
                const list = this.getListById(filter.list_id, this.lists);
                const type = fields.find((fieldName) => this.finder(list.name, values[fieldName]));
                const integrationIds = filter.list_value_ids.map((id) => this.getIntegrationId(id, list.values));

                integrationQuery[type] = list.id;
                integrationQuery[type+'_id'] = integrationIds.filter((f) => f);
            }
        );
        return integrationQuery;
    }

    openModal() {
        this.modal.onShow(this.reviewGroup);

        if (!this.modalHasOpen) {
            this.modalHasOpen = true;
            this.onChanges();
        }
    }

    onChanges() {
        this.modal.selected.subscribe((group: ReviewGroup) => {
            this.reviewGroup = group;

            this.queryData = Object.assign(this.queryData, {
                end: group.last_review_calc_id,
                init: group.review_calc_id,
                group_id: group.id,
            });

            // this.forceFilterResults = false;
            //this.updateData(null);
            this.clearAllData();
        });
    }

    clearAllData() {
        this.allData = [];
        this.groupedData = [];
    }

    canShowImage = (rev: ReviewCalc) => rev && rev.logo && rev.logo.generated_name.length;

    canShowStatus = (rev: ReviewCalc) => rev ? this.calculateStatus(rev) : 0;

    // fakeTotal is total simulated by responses count
    calculateStatus(rev: ReviewCalc) {
        const { ok, nok, review_total } = rev;
        const okNok = ok + nok;

        const weight = Math.floor((okNok * 100) / review_total);
        const simulatedTotal = Math.floor((okNok * 100) / weight);

        const approved = Math.floor((ok * 100) / simulatedTotal);
        const reproved = Math.floor((nok * 100) / simulatedTotal);

        return !review_total || !ok && !nok || simulatedTotal == Infinity ?
        'Sem valores para calcular' : `${approved}% - ${reproved}%`;
    }

    getImgContent(rev: ReviewCalc): SafeUrl {
      if (!rev || !rev.logo || !rev.logo.generated_name) return '../assets/layout/images/avatar.png';
      return this.sanitizer.bypassSecurityTrustUrl(rev.logo.generated_name);
    }

    fillListIds() {
        const keys = {
            "factory": this.factoryFilters,
            "season": this.seasonFilters,
            "status": this.statusFilters,
            "model": this.modelFilters,
            "brand": this.brandFilters,
            "line": this.lineFilters,
        };

        Object.getOwnPropertyNames(keys).forEach((field) => {
            let target = this.listOptions.find((list) =>
            this.finder(list.name, keys[field]));
            
            if (target) this.queryData[field] = target.id;
        })
    }

    getItemName(id, list: any[]) {
        const result = list.find(item => item.id == id);
        return result && result.description || false;
    };

    getIntegrationName(id, list: any[]) {
        const result = list.find(item => item.integration_id == id);
        return result && result.description || false;
    };

    getOriginId(id, list: any[]) {
        const result = list.find(item => item.integration_id == id || item.id == id);
        return result && result.id || result && result.integration_id || id;
    };

    getIntegrationId(id, list: any[]) {
        const result = list.find(item => item.id === id);
        return result && result.integration_id || null;
    };

    async addLogo() {
        this.message.success('loaded_data');

        const modelList = this.listOptions.find((item) => {
            if (this.finder(item.name, this.modelFilters))
            return item || [];
        });

        this.allData.forEach((item: ReviewCalc, i: number) => {
            if (item) {
                let modelWithMedia = modelList && modelList.values && modelList.values.find(
                (model) => item && item.model_id && model && model.id == item.model_id);

                if (modelWithMedia) this.allData[i].logo = modelWithMedia.logo;
            }
        })

        this.filterData();
    }

    async filterData() {
        if (this.forceFilterResults)
        this.allData = this.allData.filter((item) => {
            let valid = true;
            let values = this.getKeyValues();
            let excludes = ['status', 'reviewed'];
        
            excludes.forEach((field) => delete values[field]);

            Object.getOwnPropertyNames(values).forEach((field) => {
                const validation = values[field] && values[field].length;
                if (validation && !item[field+'_id']) valid = false;
            });

            return valid;
        })

        this.dataLenght = this.allData.length;
        this.groupAllData();
    }

    async groupAllData() {
        let groupedData = {};
        let newAllData = [];

        // Agrupamento
        groupBy(this.allData, (item: ReviewCalc) => item.id || item.response_id);

        this.allData.forEach((item: ReviewCalc) => {
            if (item && item.response_id) this.setMajorAndMijor(item.response_id);

            const id = `${item.factory_id}-${item.season_id}-${item.brand_id}`;

            if (!groupedData[id]) groupedData[id] = [];
            groupedData[id].push(item);
        });

        Object.getOwnPropertyNames(groupedData).forEach((id) => {
            newAllData[parseInt(id)] = groupedData[id];
        });

        this.groupedData = newAllData.filter(f => f);
        this.resultLoaded = Promise.resolve(true);
        this.loadingOnTable = false;
    }

    setMajorAndMijor = (value: number) => {
        if (this.reviewGroup.review_calc_id == 0) this.reviewGroup.review_calc_id = this.maxId;;

        const { review_calc_id: mijor, last_review_calc_id: major } = this.reviewGroup;

        if (value <= mijor) this.reviewGroup.review_calc_id = value;
        if (value >= major) this.reviewGroup.last_review_calc_id = value;
    }

    compareFields = (p: any, v: any, f1: string, f2: string) => p[f1] == v[f1] && p[f2] == v[f2];

    clearReview = () => this.reviewCalc = new ReviewCalc({});

    _handler(action: Observable<any>) {
        action.subscribe((response) => response && !response.message ?
        this.message.success('Salvo com sucesso') :
        this.message.error('Erro ao salvar'));
    }

    getAllResume = () => new Object({
        response_lenght: this.dataLenght,
        full_data_balance: this.full_data_balance,
        full_data_reviewed: this.full_data_reviewed,
        full_data_order_count: this.full_data_order_count,
        full_data_review_total: this.full_data_review_total,
    })

    exportReport() {
        this.calculateForReport();

        const report = JSON.stringify(this.groupedDataDto);
        const resume = JSON.stringify(this.getAllResume());

        localStorage.setItem('report', report);
        localStorage.setItem('resume', resume);
    }

    exportCSV() {
        if (!this.existData()) return;
        
        this.loading = true;
        
        const title = 'Controle de revisão - ';
        const header = this.generateHeaderCSV();
        const fullData = this.generateTotalCSV();
        
        this.generateFullCSV(header, fullData, title);
    }

    generateHeaderCSV() {
        let headerColums = [
            { key: 'brand_name', name: 'Marca', formatting: this.nullSafe },
            { key: 'factory_name', name: 'Fábrica', formatting: this.nullSafe },
            { key: 'season_name', name: 'Coleção', formatting: this.nullSafe },
            { key: 'line_name', name: 'Construção', formatting: this.nullSafe },
            { key: 'model_name', name: 'Modelo', formatting: this.nullSafe },
            
            { key: 'order_count', name: 'Qtd. de Pedidos', formatting: this.nullSafe },
            { key: 'review_total', name: 'Total a Revisar', formatting: this.nullSafe },
            { key: 'review_percentage', name: '% a Revisar', formatting: (v) => v + '%' },
            
            { key: 'reviewed', name: 'Revisados' },
            { key: 'balance', name: 'Saldo a Revisar' },
        ];

        return Exporting.generateCSV(headerColums, this.allData);
    }

    generateTotalCSV() {
        const values = {
            full_data_review: this.full_data_review_total,
            full_data_balance: this.full_data_balance,
            full_data_reviewed: this.full_data_reviewed,
        };
        
        const headerColums = [
            { key: 'full_data_review', name: 'Total a revisar', formatting: this.nullSafe },
            { key: 'full_data_reviewed', name: 'Revisados', formatting: this.nullSafe },
            { key: 'full_data_balance', name: 'Saldo a revisar', formatting: this.nullSafe },
        ];

        return Exporting.generateCSV(headerColums, [values]);
    }

    generateFullCSV(header, body, title) {
        if (!this.existData()) return this.message.error('Sem dados para exportar');

        const now = new Date().toUTCString();
        const shortString = 'Exportado: '+ now;
        const longString = 'Resumo Total Geral';

        const csv = new Array().concat([shortString, '\n'], header, ['\n', longString, '\n'], body);

        Exporting.downloadCSV(csv, title + now);

        this.loading = false;
    }

    nullSafe = (v) => v ? v : 'Não informado'
    
    existData = () => this.allData.length;

    filterErrorMsg = (name: string) => 
    this.message.error('Cadastro invalido no nome da lista [' + name + '] usando posição padrão.');

    finder = (item: string, list: any[]) => list.filter(p => (item.toLocaleLowerCase().includes(p))).length > 0;

    loadFactoriesAndModels() {
        this.message.info(this.loadListMessage);

        this.disabled = true;

        this.listValueService
            .getAllWithListByParams({integrationOnly: true})
            .subscribe((listWithValues: ListModel[]) => {
                if (listWithValues && listWithValues.length) {
                    this.listOptions = listWithValues;
                    this.lists = listWithValues;

                    const loadList = (list) => listWithValues.find((item) => {
                        if (this.finder(item.name, list)) {
                            this.list_id.push(item.id);
                            return true;
                        }
                    });

                    const loadValue = (list) => list.values
                        .map((data) => {
                            return Object.assign({
                                label: data.description,
                                value: data,
                            })
                        }
                    );

                    let factories = loadList(this.factoryFilters);
                    let seasons = loadList(this.seasonFilters);
                    let brands = loadList(this.brandFilters);
                    let models = loadList(this.modelFilters);
                    let lines = loadList(this.lineFilters);

                    let status = loadList(this.statusFilters);

                    if (!factories) {
                        factories = listWithValues[0];
                        this.filterErrorMsg('fabricas');
                    } else {
                        this.factoryOptions = loadValue(factories);
                        this.listOptionsReview['factory_id'] = factories.id;
                        factories.values.forEach((item) => this.factoryList.push(item));
                    }

                    if (!brands) {
                        brands = listWithValues[1];
                        this.filterErrorMsg('marcas');
                    } else {
                        this.brandOptions = loadValue(brands);
                        this.listOptionsReview['brand_id'] = brands.id;
                        brands.values.forEach((item) => this.brandList.push(item));
                    }

                    if (!models) {
                        models = listWithValues[2];
                        this.filterErrorMsg('modelos');
                    } else {
                        this.modelOptions = loadValue(models);
                        this.listOptionsReview['model_id'] = models.id;
                        models.values.forEach((item) => this.modelList.push(item));
                    }

                    if (!seasons) {
                        seasons = listWithValues[3];
                        this.filterErrorMsg('coleção');
                    } else {
                        this.seasonOptions = loadValue(seasons);
                        this.listOptionsReview['season_id'] = seasons.id;
                        seasons.values.forEach((item) => this.seasonList.push(item));
                    }

                    if (!lines) {
                        lines = listWithValues[4];
                        this.filterErrorMsg('construção');
                    } else {
                        this.lineOptions = loadValue(lines);
                        this.listOptionsReview['line_id'] = lines.id;
                        lines.values.forEach((item) => this.lineList.push(item));
                    }

                    if (!status) {
                        status = listWithValues[5];
                        this.filterErrorMsg('status');
                        console.log('status is not a integration, put integration_id in database to show');
                    } else {
                        this.statusOptions = loadValue(status);
                        this.listOptionsReview['status_id'] = status.id;
                        status.values.forEach((item) => this.statusList.push(item));
                    }

                    this.message.success('Filtros Carregados');
                    this.listsLoaded = Promise.resolve(true);
                    this.disabled = false;
                } else {
                    this.message.error('Falha ao carregar listas');
                }
            }
        );
    }

    createReview() {
        if (!this.selectedFactory || !this.selectedGroup || !this.selectedBrand || !this.selectedModel || !this.selectedLine)
        return this.message.error('Por favor preencha todos os campos');

        const id = this.reviewGroup.review_calc_id - 2;

        this.reviewCalc.response_id = id > 0 ? id + 1 : 0;

        this.reviewCalc.line_id = this.selectedLine.id;
        this.reviewCalc.model_id = this.selectedModel.id;
        this.reviewCalc.brand_id = this.selectedBrand.id;
        this.reviewCalc.season_id = this.selectedSeason.id;
        this.reviewCalc.factory_id = this.selectedFactory.id;
        // this.reviewCalc.review_group_id = this.selectedGroup.id;

        this._saveReview(this.reviewCalc);
        this.clearReview();
    }

    _deleteReview = (id: number) => this.reviewService.delete(id)
    .pipe(take(1)).subscribe(({ error, message }) => !error ?
    this.message.success(message) :
    this.message.error(message));

    _saveReview(rev: ReviewCalc) {
        const review = new ReviewCalc(rev);

        if (!review.order_count || !review.review_percentage)
        return this.message.warn(this.selectMessage, 3 * 1000);

        // review.reviewed = 0; - review calc on sync

        const action = review.id ? this.reviewService.put(review) : this.reviewService.post(review);

        this._handler(action);
    };

    calculateGroupTotal(group: ReviewCalc[], param: string) {
        if (!group || !group.length || !param) return 0;
    
        const realValues = group.map((data) => {
            data.calculateReviewBalance();
    
            return data[param] || 0;
        });
    
        const positiveValues = group.map((data) => {
            data.calculateReviewBalance();
    
            const result = data[param] || 0;
            return result > -1 ? result : 0;
        });
    
        const realSum = realValues.reduce((a, b) => a + b);
        const positiveSum = positiveValues.reduce((a, b) => a + b);
    
        if (realSum == positiveSum) return realSum;
        else return this.onlyInteger ? positiveSum : realSum;
    }

    calculateAll() {
        if (!this.allData || this.allData && !this.allData.length) return 0;

        const sum = (array: number[]) => array.reduce((a: number, b: number) => a + b);
        // const allData = this.groupedData.flatMap(a => a) as ReviewCalc[]; // not required

        const allTotalValues = this.allData.map(rev => this.onlyNotNegativeValues(rev, 'balance'));
        const allTotalReviewed = this.allData.map(rev => this.onlyNotNegativeValues(rev, 'reviewed'));
        const allReviewValues = this.allData.map(rev => this.onlyNotNegativeValues(rev, 'review_total'));
        const allOrderCountValues = this.allData.map(rev => this.onlyNotNegativeValues(rev, 'order_count'));

        this.full_data_balance = sum(allTotalValues);
        this.full_data_reviewed = sum(allTotalReviewed);
        this.full_data_review_total = sum(allReviewValues);
        this.full_data_order_count = sum(allOrderCountValues);
    }

    onlyNotNegativeValues(object: any, field: string) {
        if (!this.onlyInteger) return object[field] || 0;
        return object[field] && object[field] > -1 ? object[field] : 0;
    };

    calculateForReport() {
        const numberFields = ['order_count', 'review_total', 'review_percentage', 'reviewed', 'balance'];
        const stringFields = ['factory_name', 'brand_name', 'season_name'];
        const fields = new Array().concat(numberFields, stringFields);

        this.groupedData.forEach((group) => {

            fields.forEach((field) => {

                if (!group || !group.length || !field) return 0;

                const values = group.map((data) => {
                    data.calculateReviewBalance();

                    return data[field] || 0;
                });

                const result = numberFields.includes(field) ? values.reduce((a, b) => a + b) : values[0];
                const index = this.groupedData.findIndex((grouped) => grouped == group);

                if (!this.groupedDataDto[index]) this.groupedDataDto[index] = {};

                this.groupedDataDto[index][field] = result;
            })
        })

        this.groupedDataDto = this.groupedDataDto.filter((data) => {
            let valid: boolean = true;

            numberFields.forEach((field) => {
                if (!data[field]) valid = false;
            })

            return valid
        });
    }

    getGroups() {
        this.groupOptions = [];

        this.reviewGroupService.getAll().subscribe(({ rows }) => {
            this.groupList = rows as ReviewGroup[];

            rows.map((group) => {
                this.groupOptions.push({
                    label: group.description,
                    value: group,
                });
            })
        })
    };

    getMidiaFromExternal(name?: string) {
        let imageName = name || 'Content/pictures/2594_0001_0054.png';
        let exist = sessionStorage.getItem(imageName);
        let result: string = '';

        if (exist) result = exist;
        else this.reviewService.getFileExternal(imageName).subscribe((image: Buffer)=> {
            result = 'data:image/jpeg;base64,' + Buffer.from(image).toString('base64');
            sessionStorage.setItem(imageName, result);
        });
    }

    translate = (key: string) => this.translateService.instant(key || "invalid");
}

interface ListView<Generic> {
    label: string;
    value: Generic;
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/review/review.component.ts